import { Button, type ButtonProps } from '@mui/material'

function CustomButton({ children, ...restProps }: ButtonProps) {
  return (
    <Button variant="contained" color="secondary" disableElevation {...restProps}>
      {children}
    </Button>
  )
}
export default CustomButton
